import { render, staticRenderFns } from "./user-change.vue?vue&type=template&id=3b5e5969&"
import script from "./user-change.vue?vue&type=script&lang=js&"
export * from "./user-change.vue?vue&type=script&lang=js&"
import style0 from "./user-change.vue?vue&type=style&index=0&id=3b5e5969&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports